import type { IAddressInfo } from "@kiraah-shared/common";

/** Champs nécessaires pour un rendu lecture seule (instance {@link Address} ou DTO API). */
export type MobileTicketAddressFrag = Pick<
  IAddressInfo,
  "StreetNumber" | "StreetName" | "ZipCode" | "City" | "FurtherInformation" | "Country"
>;

/** Affichage lisible d’une adresse livraison (données déjà présentes sur le ticket). */
export function formatTicketDeliveryAddressLines(addr: MobileTicketAddressFrag | undefined | null): string[] {
  if (!addr) {
    return [];
  }
  const line1 = [addr.StreetNumber, addr.StreetName].filter(Boolean).join(" ").trim();
  const line2 = [addr.ZipCode, addr.City].filter(Boolean).join(" ").trim();
  const lines: string[] = [];
  if (line1) {
    lines.push(line1);
  }
  if (addr.FurtherInformation?.trim()) {
    lines.push(addr.FurtherInformation.trim());
  }
  if (line2) {
    lines.push(line2);
  }
  if (addr.Country?.trim()) {
    lines.push(addr.Country.trim());
  }
  return lines;
}
